export default {"src":"/_next/static/media/chronicIcon.25a37d7d.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};